// extracted by mini-css-extract-plugin
export default {"items":"items___sqZke","slider":"slider___jpJDa","progress":"progress___GzYt7","arrows":"arrows___OSQwm","prev_btn":"prev_btn___zG0cy","next_btn":"next_btn___PQsvQ"};